import { createAsyncThunk } from '@reduxjs/toolkit';
import { getOrPromiseReject } from 'tccc-utils';
import { WebRtcMap } from '../../trtc/trtc';
import { SessionIdParams } from './sessions.thunk';
import { InvalidParamsError, NotFoundError } from '../../common/TcccError';
import { TcccSdk } from '../../tccc';

export const startRealtimeAsr = createAsyncThunk(
  'asr/startRealtimeAsr',
  async (params: { sessionId: string; sdk: TcccSdk }) => {
    const { sessionId } = await getOrPromiseReject(SessionIdParams)(params);
    if (!sessionId) {
      throw new InvalidParamsError('sessionId', sessionId);
    }
    const webRtc = WebRtcMap.get(sessionId);
    if (!webRtc) {
      throw new NotFoundError('session', sessionId);
    }
    try {
      await webRtc.startRealtimeAsr();
      params.sdk.Call.updateOne(sessionId, { isStartRealtimeAsr: true });
    } catch (e) {
      throw e;
    }
    return {
      sessionId,
    };
  },
);

export const stopRealtimeAsr = createAsyncThunk(
  'asr/stopRealtimeAsr',
  async (params: { sessionId: string; sdk: TcccSdk }) => {
    const { sessionId } = await getOrPromiseReject(SessionIdParams)(params);
    if (!sessionId) {
      throw new InvalidParamsError('sessionId', sessionId);
    }
    const webRtc = WebRtcMap.get(sessionId);
    if (!webRtc) {
      throw new NotFoundError('session', sessionId);
    }
    try {
      await webRtc.stopRealtimeAsr();
      params.sdk.Call.updateOne(sessionId, { isStartRealtimeAsr: false });
    } catch (e) {
      throw e;
    }
    return {
      sessionId,
    };
  },
);
